<template>
  <div>
    <div class="breadcrumb-wrap">
      <div>{{this.$store.state.name}}</div>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-custom">
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-button v-if="myResources.indexOf('/admin/create/user') !== -1" @click='addUserClick' size="small" type="primary" style="margin-bottom: 8px">创建用户</el-button>
    <el-dialog :visible.sync="addUserVisible" title="新增用户" @close="cleanForm('addUserForm')">
        <el-form :model="addUserObj" status-icon :rules="rules" label-width="80px" ref="addUserForm" class="ruleForm">
            <el-form-item label="用户名" prop="username">
                <el-input class="margin-space" placeholder="请输入用户名" v-model="addUserObj.username">
                </el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" class="margin-space" placeholder="请输入密码" v-model="addUserObj.password">
                </el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input class="margin-space" placeholder="请输入手机号码" type='number' v-model="addUserObj.mobile">
                </el-input>
            </el-form-item>
            <div style="text-align: right" class="margin-space">
                <el-button :loading="addUserLoading" type="primary" @click="addConfirmClick('addUserForm')">
                提交
                </el-button>
            </div>
        </el-form>
    </el-dialog>
    <LoadingNoDialog :loading="loading">

      <el-table
        v-if="myResources.indexOf('/admin/users/list') !== -1"
        class="clear-fix"
        border
        :data="tableData"
        style="width: 100%">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          label="用户名"
          prop="username"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
        >
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号码">
        </el-table-column>
        <el-table-column
          :formatter="formatterUserType"
          prop="type"
          label="用户类型">
        </el-table-column>
        <el-table-column
          :formatter="formatterRow"
          prop="role"
          label="拥有角色">
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="用户创建时间">
        </el-table-column>
        <el-table-column
          prop="s"
          label='操作'
          align="center"
          fixed="right"
          width="180">
          <template slot-scope="scope">
            <template v-if="myResources.indexOf('/admin/user-to-role') !== -1">
              <el-button
                type="success"
                plain
                size="mini"
                @click="setRole(scope.$index, scope.row)">分配角色
              </el-button>
            </template>
            <template v-if="myResources.indexOf('/admin/delete/user') !== -1">
              <el-button
                type="danger"
                size="mini"
                plain
                :loading="loadArr[scope.$index]"
                @click="deleteRole(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 10px;text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10,20, 50, 100, 500,1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

    </LoadingNoDialog>
    <RoleSelect ref="RoleSelect" @sure="handleSure"/>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import LoadingNoDialog from '../../components/LoadingNoDialog.vue'
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
  import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component.vue";
  import RoleSelect from './components/RoleSelect.vue'
import { setTimeout } from 'timers';

  export default {
    name: 'Role',
    data() {
        let mobileCheck = (rule, value, callback) => {
            let mobileReg = /^[1][3,4,5,7,8][0-9]{9}$/
            let isMobile = mobileReg.test(this.addUserObj.mobile)
            if (!isMobile) {
                callback(new Error('请输入正确的手机号码'))
            }else{
                callback();
            }
        }
      return {
        size: 10,
        page: 1,
        tableData: [],
        total: 0,
        loading: false,
        addUserVisible: false,
        addUserLoading: false,
        loadArr:[],
        addUserObj: {
          username: '',
          password: '',
          mobile: ''
        },
        rules:{
            username:[
                {required:true,message:'用户名不能为空',trigger:'blur'}
            ],
            password:[
                {required:true,message:'密码不能为空',trigger:'blur'}
            ],
            mobile:[
                {required:true,message:'手机不能为空',trigger:'blur'},
                {validator:mobileCheck,trigger:'blur'}
            ]
        },
        myResources:[]
      }
    },
    components: {
      ElDialog,
      ElButton,
      LoadingNoDialog,
      RoleSelect
    },
    mounted() {
      this.getList();
    },
    methods: {
      async getList() {
        this.loading = true
        let r = await axios.get('/admin/users/list', {params: {page: this.page, size: this.size}})
        this.tableData = r.rows.map(item => Object.assign(item, {createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm:ss')}))
        this.total = r.count
        this.loadArr = []
        for(let i=0; i<r.count; i++){
            this.loadArr.push(false);
        }
        this.getMyResources();
        this.loading = false
      },
      async getMyResources() {
        let r = await axios.get('/admin/my-resources');
        this.myResources = r.data.map(item => item.apiUrl);
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      formatterRow(rows, colum) {
        if (rows.roles.length == 0) {
          return '无'
        }
        return rows.roles.map(item => item.roleName).join(', ')
      },
      formatterUserType(rows, colum) {
        if (rows.type == -2) {
          return '超级管理员'
        }
        if (rows.type == -1) {
          return '后台管理员'
        }
        if (rows.type == 0) {
          return '普通用户'
        }
        if (rows.type == 1) {
          return '企业用户'
        }
        if (rows.type == 2) {
          return '设计师用户'
        }

      },
      cleanForm(formName){
        this.$refs[formName].resetFields();
      },
      handleSure() {
        this.getList()
      },
      addUserClick() {
        this.addUserVisible = true
      },
      setRole(index, row) {
        this.$refs.RoleSelect.setVisible(true, row)
      },
      deleteRole(index, row){
        this.loadArr[index] = true;
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
            let r = await axios.delete('/admin/delete/user',{
                params:{
                    id:row.id
                }
            });
            if(r.code == 0){
                this.$message.success('删除成功')
            }
            this.getList();
            this.loadArr[index] = false;
        }).catch(() => {
          this.loadArr[index] = false;
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      addConfirmClick(formName) {
        this.$refs[formName].validate(async valid => {
            if(valid){
                this.addUserLoading = true
                let r = await axios.post('/admin/create/user', this.addUserObj)
                if (r.code == 1001) {
                    this.$message.warning('用户名或密码后手机号码为空！')
                    this.addUserLoading = false
                    return
                }
                if (r.code == 122) {
                    this.$message.warning('手机号码或用户名已经存在')
                    this.addUserLoading = false
                    return
                }
                if(r.code == 0){
                    this.$message.success('创建成功');
                }
                this.$refs[formName].resetFields();
                this.addUserLoading = false
                this.addUserVisible = false
                this.getList()
            }
        })
      }
    }
  }
</script>

<style>
.el-form-item__error{
    margin-left: 20px;
}
input[type=number] {
    -moz-appearance:textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/main/permission/Admin.vue